<!-- src/components/SubscriptionPlans/SubscriptionPlanFormSkeleton.vue -->
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader type="text" class="field-skeleton" />
      </v-col>

      <v-col cols="12" md="6">
        <v-skeleton-loader type="text" class="field-skeleton" />
      </v-col>

      <v-col cols="12" md="6">
        <v-skeleton-loader type="text" class="field-skeleton" />
      </v-col>

      <v-col cols="12" md="4" v-for="item in 3" :key="`top-${item}`">
        <v-skeleton-loader type="text" class="field-skeleton" />
      </v-col>

      <v-col cols="12">
        <v-skeleton-loader type="paragraph" class="textarea-skeleton" />
      </v-col>

      <v-col cols="12" md="4" v-for="item in 5" :key="`select-${item}`">
        <v-skeleton-loader type="text" class="field-skeleton" />
      </v-col>
    </v-row>

    <div class="d-flex justify-space-between align-center mb-3 mt-2">
      <v-skeleton-loader type="text" width="120" />
      <v-skeleton-loader type="button" width="130" />
    </div>

    <v-card
      v-for="item in 2"
      :key="`feature-${item}`"
      outlined
      class="feature-skeleton-card mb-4"
    >
      <v-card-text class="px-md-4 pb-md-0 pt-md-6">
        <v-row>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="text" class="field-skeleton" />
          </v-col>

          <v-col cols="12" md="4">
            <v-skeleton-loader type="text" class="field-skeleton" />
          </v-col>

          <v-col cols="12" md="2">
            <v-skeleton-loader type="text" class="field-skeleton" />
          </v-col>

          <v-col cols="12" md="3" class="d-flex justify-space-between align-center">
            <v-skeleton-loader type="text" width="120" />
            <v-skeleton-loader type="avatar" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-end pt-0 mt-md-6">
      <v-skeleton-loader type="button" width="100" class="mr-2" />
      <v-skeleton-loader type="button" width="100" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionPlanFormSkeleton",
};
</script>

<style scoped>
.field-skeleton {
  height: 56px;
}

.textarea-skeleton {
  min-height: 96px;
}

.feature-skeleton-card {
  border-radius: 10px;
  border-color: #e5e7eb !important;
  box-shadow: none !important;
}
</style>